<template>
    <div>
        <MessengerNavigation :title="getHeadline()"/>



            <div class="container">
                <div class="row justify-content-md-center">
                    <div class="col-md-8">
                        <div class="messages">
                            <div v-for="msg in messages" class="message-cont" :class="{isMine:amISender(msg)}">
                                <div class="message">
                                    <!--<span class="from">name?</span>-->
                                    <span class="text">{{msg.message}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>



        <div class="send-panel">
            <div class="container">
                <form class="form-horizontal">
                    <div class="form-row align-items-center">
                        <div class="col-12 col-xs-11">

                            <div class="input-group">
                                <span class="d-xs-block d-sm-none mr-4">&nbsp;</span>
                                <input class="form-control" type="text" v-model="message"/>
                                <div class="input-group-btn">
                                    <button class="btn btn-primary" @click.prevent="sendMessage" :disabled="message.length<1">Send</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        </div>



    </div>
</template>

<script>

  import MainNavigation from "../layout/MainNavigation";
  import MessengerNavigation from "../layout/MessengerNavigation";
  import CenteredCard from "../layout/CenteredCard";


  export default {
    name: "MessengerDetailPage",
    data(){
      return {
        conversation: {_id:false},
        blog: {},
        messages: [],
        message: '',
        toUserId: null
      }
    },
    mounted(){
      let blogUrl  = this.$route.params.blogUrl;
      let convId   = this.$route.params.conversationId;
      let toUserId = this.$route.params.userId;

      if(blogUrl && toUserId){
        this.toUserId = toUserId;
        this.$api.getConversationByUserIdAndBlogUrl(toUserId, blogUrl)
          .then((res)=>{
            this.initConversation(res.data);
          })
      }

      if(blogUrl && !toUserId){
        this.$api.getConversationByBlogUrl(blogUrl)
          .then((res)=>{
            this.initConversation(res.data);
          })
      }

      if(convId){
        this.$api.getConversationById(convId)
          .then((res)=>{
            this.initConversation(res.data);
          })
      }

    },
    sockets: {
      conversationCreated(data){
          this.conversation = data.conversation;
      },
      receiveMessage(message){
        if(this.conversation && this.conversation._id.toString() === message.conversation.toString()) {
          this.addMessage(message);
          message.token = this.$store.state.user.token;
          this.messageRead(message);
        }
      }
    },

    methods: {
        initConversation(convData){
          this.blog = convData.blog;
          this.conversation = convData.conversation;
          this.messages = convData.messages.reverse();
          this.$nextTick(()=>{
            this.scrollToBottom();
            this.$bus.$emit('messenger.reloadMessageCount');
          });
        },
        addMessage(msg){
          this.messages.push(msg);
          this.scrollToBottom();
        },
        messageRead(msg){
          this.$socket.emit('messageRead', msg);
        },
        sendMessage(){
            if(this.message.length<1) return;
            let msg = {
              token: this.$store.state.user.token,
              message: this.message,
              author: this.$store.getters['user/id']
            };

            if(this.conversation){
              msg.conversationId = this.conversation._id;
            } else {
              msg.blogUrl = this.blog.url;
              if(this.toUserId) msg.toUserId = this.toUserId;
            }
            this.$socket.emit('sendMessage', msg)
            this.addMessage(msg);
            this.message = '';
        },
        amISender(message){
          let userId = this.$store.getters['user/id'];
          return (message.author.toString() === userId.toString())
        },
        scrollToBottom(){
          // Animate!
          this.$nextTick(()=> {
            window.scrollTo(0, document.body.scrollHeight);
          });
        },
        getHeadline(){
          let userId = this.$store.getters['user/id'];
          if(!this.conversation || !this.conversation.sender || !this.conversation.recipient){
            return this.blog.title;
          }
          if(this.conversation.sender === userId || this.conversation.sender._id === userId){
            return this.conversation.recipient.blog.title
          } else {
            return this.conversation.sender.name+ "@" + this.conversation.recipient.blog.title
          }
        }
    },
    components: {
      CenteredCard,
      MainNavigation,
      MessengerNavigation
    }
  }
</script>

<style lang="sass" scoped>
    @import '../../assets/sass/vars.scss'

    .send-panel
        position: fixed
        bottom: 0px
        background-color: #FFF
        padding: 10px
        left: 0
        right: 0

    .messages
        padding-bottom: 100px

    .message
        border-radius: 1em
        box-shadow: 1px 1px 0px rgba(0,0,0,.1)
        display: inline-block
        background-color: #EEE
        padding: .5em 1em
        margin: .4em
        max-width: 90%

        .from
            font-size: .6em

    .isMine
        text-align: right

        .message
            background-color: $colorPrimary
            color: #FFF





</style>



// WEBPACK FOOTER //
// src/components/messenger/MessengerDetailPage.vue